import React from 'react'
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import BgVideo from "../video/bg-video.mov"
function Home() {
  const location = useLocation();
  
  useEffect(() => {
      const name = location.pathname;
      document.body.className = name.substring(1) + "-body";
  }, [location]);
  return (
  
    <video autoPlay loop muted className="bg-vid">
      <source src={BgVideo} type="video/mp4" />
      Your browser does not support the video tag.
    </video>
  
  )
}

export default Home
